import { render, staticRenderFns } from "./GatewaySummaryPanel.global.vue?vue&type=template&id=baf040c2&scoped=true&lang=pug&"
import script from "./GatewaySummaryPanel.global.vue?vue&type=script&lang=ts&"
export * from "./GatewaySummaryPanel.global.vue?vue&type=script&lang=ts&"
import style0 from "./GatewaySummaryPanel.global.vue?vue&type=style&index=0&id=baf040c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf040c2",
  null
  
)

export default component.exports